import { render, staticRenderFns } from "./AccessProperty.vue?vue&type=template&id=7f67a0d2"
import script from "./AccessProperty.vue?vue&type=script&lang=js"
export * from "./AccessProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports